import React from 'react';
import { UserDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import UserDrillDownTableRow from '../UserDrillDownTableRow/UserDrillDownTableRow';

type UserDrillDownTableBodyProps = {
  items: Array<UserDrillDownItem>;
};

const UserDrillDownTableBody: React.FC<UserDrillDownTableBodyProps> = ({
  items,
}) => {
  return (
    <tbody>
      {items.map((item) => (
        <UserDrillDownTableRow key={item.id} item={item} />
      ))}
    </tbody>
  );
};

export default UserDrillDownTableBody;
